import { render } from "./TargetSourceTranslationBlock.vue?vue&type=template&id=2ead0427&scoped=true"
import script from "./TargetSourceTranslationBlock.vue?vue&type=script&lang=js"
export * from "./TargetSourceTranslationBlock.vue?vue&type=script&lang=js"

import "./TargetSourceTranslationBlock.vue?vue&type=style&index=0&id=2ead0427&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ead0427"]])

export default __exports__